var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.332 13.3333H14.6654V12C14.6654 10.8954 13.7699 10 12.6654 10C12.0283 10 11.4608 10.2979 11.0945 10.7619M11.332 13.3333H4.66536M11.332 13.3333V12C11.332 11.5625 11.2477 11.1447 11.0945 10.7619M4.66536 13.3333H1.33203V12C1.33203 10.8954 2.22746 10 3.33203 10C3.9691 10 4.5366 10.2979 4.90286 10.7619M4.66536 13.3333V12C4.66536 11.5625 4.74965 11.1447 4.90286 10.7619M4.90286 10.7619C5.39437 9.53402 6.59524 8.66667 7.9987 8.66667C9.40215 8.66667 10.603 9.53402 11.0945 10.7619M9.9987 4.66667C9.9987 5.77124 9.10327 6.66667 7.9987 6.66667C6.89413 6.66667 5.9987 5.77124 5.9987 4.66667C5.9987 3.5621 6.89413 2.66667 7.9987 2.66667C9.10327 2.66667 9.9987 3.5621 9.9987 4.66667ZM13.9987 6.66667C13.9987 7.40305 13.4017 8 12.6654 8C11.929 8 11.332 7.40305 11.332 6.66667C11.332 5.93029 11.929 5.33334 12.6654 5.33334C13.4017 5.33334 13.9987 5.93029 13.9987 6.66667ZM4.66536 6.66667C4.66536 7.40305 4.06841 8 3.33203 8C2.59565 8 1.9987 7.40305 1.9987 6.66667C1.9987 5.93029 2.59565 5.33334 3.33203 5.33334C4.06841 5.33334 4.66536 5.93029 4.66536 6.66667Z",
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/UserGroup.a218d6f5dfb63c53cc3d4f34d43a589f.svg";
export { ForwardRef as ReactComponent };